import { useQuery } from "@tanstack/react-query"
import { getCampaignHealthQuery } from "modules/backoffice/lib/campaigns/getCampaignHealthQuery"
import { OrganizationType } from "schema"

type Options = {
  enabled?: boolean
}

export function useGetCampaignHealthQuery(
  query: { organizationTypes: OrganizationType[]; search?: string },
  options?: Options,
) {
  return useQuery({
    ...getCampaignHealthQuery(query),
    enabled: options?.enabled,
  })
}
